<template>
  <WdsStack v-if="show" class="actions-container">
    <a class="tw-w-full" :href="route" @click="$emit('click')">
      <WdsStack class="tw-items-center tw-w-full">
        <WdsIcon :name="icon" :size="30" class="tw-text-gray-800" />
        <WdsStack class="tw-justify-between tw-items-center tw-w-full tw-pl-3">
          <WdsStack direction-column>
            <WdsStack>
              <WdsText>
                <span class="tw-text-gray-700">{{ title }}</span>
              </WdsText>
            </WdsStack>
            <WdsStack>
              <slot></slot>
            </WdsStack>
          </WdsStack>
          <WdsStack gap-sm class="tw-items-center">
            <WdsText bold :text="actionText" />
            <WdsIcon :size="14" :name="WdsIconNameEnum.CHEVRON_RIGHT" class="tw-text-gray-800" />
          </WdsStack>
        </WdsStack>
      </WdsStack>
    </a>
  </WdsStack>
</template>

<script setup lang="ts">
import { WdsIcon, WdsIconNameEnum, WdsStack, WdsText } from '@worksome/wds-components'

defineEmits(['click'])

defineProps<{
  show: boolean
  icon: WdsIconNameEnum
  title: string
  actionText: string
  route: string
}>()
</script>

<style lang="scss" scoped>
.actions-container {
  @apply tw-bg-white;
  @apply tw-rounded;
  @apply tw-p-2;
  @apply tw-border-2;
  @apply tw-border-transparent;
  @apply tw-transition;
  @apply tw-duration-200;
}

.actions-container:hover {
  @apply tw-border-2;
  @apply tw-border-gray-200;
}
</style>
